module.exports = __webpack_public_path__ + "static/media/ratatool-logo.4975095c.png";